import { createAction } from '@reduxjs/toolkit'

import type {
  AccountUpdatePayload,
  ChangeEmailPayload,
  EmailChoices,
  EmailChoicesChange,
  OtpState,
  VerifyOtpPayload,
} from './types'

export const InternalAccountActions = {
  updateRequest: createAction<AccountUpdatePayload>(
    'ACCOUNT_INTERNAL_UPDATE_REQUEST'
  ),
  setOtp: createAction<OtpState>('ACCOUNT_INTERNAL_SET_OTP'),
  clearOtp: createAction('ACCOUNT_INTERNAL_CLEAR_OTP'),
  updateOtp: createAction<Partial<OtpState>>('ACCOUNT_INTERNAL_UPDATE_OTP'),
  setEmails: createAction<EmailChoices | null>('ACCOUNT_INTERNAL_SET_EMAILS'),
}

export const AccountActions = {
  update: createAction<AccountUpdatePayload>('ACCOUNT_UPDATE'),
  delete: createAction('ACCOUNT_DELETE'),
  changeEmail: createAction<ChangeEmailPayload>('ACCOUNT_CHANGE_EMAIL'),
  verifyOtp: createAction<VerifyOtpPayload>('ACCOUNT_VERIFY_OTP'),
  clearOtpError: createAction('ACCOUNT_CLEAR_OTP_ERROR'),
  updateEmails: createAction<EmailChoicesChange>('ACCOUNT_UPDATE_EMAILS'),
}
